// extracted by mini-css-extract-plugin
export var textInput = "_le-0";